import { Component, EventEmitter, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-pruefblatt',
  templateUrl: './pruefblatt.component.html',
  styleUrls: ['./pruefblatt.component.scss']
})
export class PruefblattComponent {

  @Output()
  printPruefblatt = new EventEmitter<void>();

  modelUpdate$ = new BehaviorSubject(null);

  onBeenden() {
    this.modelUpdate$.next({});
    //navigate to startseite
    window.location.href = location.origin;
  }

  onReprint() {
    this.printPruefblatt.emit();
  }

}

